import React, { useEffect } from 'react'

import AppSidebar from './app/Sidebar'

import styles from './main.module.scss'
import { useSelector } from 'react-redux'
import AppHeader from './app/Header'
import AppFooter from './app/Footer'
import MobileBottomMenu from './app/MobileBottomMenu'
import { useLocation } from 'react-router-dom'
import UserAgreement from '../ui/modals/UserAgreement'

const MainLayout = ({ children }) => {
  const { pathname } = useLocation()
  const { user } = useSelector((state) => state.users)
  const [sidebarOpen, setSidebarOpen] = React.useState(false)
  const [useAgreementOpen, setUseAgreementOpen] = React.useState(false)

  useEffect(() => {
    if (user && !user.agreementAccepted) {
      setUseAgreementOpen(true)
    }
  }, [user])

  return (
    <div className={styles.layout} data-layout="app" data-page={pathname}>
      <AppHeader user={user} />
      <div
        className={`animate__animated animate__fadeIn ${styles.sidebar}`}
        data-open={sidebarOpen}
      >
        <AppSidebar user={user} setSidebarOpen={setSidebarOpen} />
      </div>
      <div className={`${styles.wrapper}`}>
        <div className="container container__main">
          <main>
            {[
              '/app/trading-station/smart-money',
              '/app/trading-station/rsi-ob',
              '/app/trading-station/rsi-ob-algo',
              '/app/trading-station/smart-money-multiscreen',
            ].includes(pathname) ? (
              children
            ) : (
              <div className="animate__animated animate__fadeIn animate__slow">
                {children}
              </div>
            )}
          </main>
          <AppFooter />
        </div>
      </div>
      <MobileBottomMenu
        user={user}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      />
      <UserAgreement user={user} isOpen={useAgreementOpen} />
    </div>
  )
}

export default MainLayout
